import { render } from "./PatientDiariesSheet.vue?vue&type=template&id=1e97f3cb"
import script from "./PatientDiariesSheet.vue?vue&type=script&lang=ts"
export * from "./PatientDiariesSheet.vue?vue&type=script&lang=ts"
script.render = render

export default script